// extracted by mini-css-extract-plugin
export default {"page":"Auth_page__hBpKD","title":"Auth_title__xzSKM","subtitle":"Auth_subtitle__F82og","input-label":"Auth_input-label__Rl90S","input":"Auth_input__njf2M"};